import { EcoSystem, Firm, JobType, Tool, mediaType } from './firm/mapper'

/**
 * Format the number of offers
 * @param nbOffers - The number of offers
 * @returns The formatted number of offers
 */
export function formatNbOffers(nbOffers: number | undefined): string {
  if (nbOffers === undefined) {
    return 'Candidature spontanée'
  }
  switch (nbOffers) {
    case 0:
      return 'Candidature spontanée'
    case 1:
      return "1 Offre d'emploi"
    default:
      return `${nbOffers} Offres d'emploi`
  }
}

/**
 * Format the number of offices
 * @param nbTotalOffices - The number of offices
 * @returns The formatted number of offices
 */
export function formatNbOffices(nbTotalOffices: number | undefined): number | null {
  if (nbTotalOffices === undefined) {
    return null
  }
  switch (nbTotalOffices) {
    case 0:
    case 1:
      return null
    default:
      return nbTotalOffices - 1
  }
}

export type FirmData = {
  data: string | mediaType | Tool[] | JobType[] | EcoSystem[] | null
  // data: any
  type:
  | 'image'
  | 'video'
  | 'firmValues'
  | 'clientDescription'
  | 'tools'
  | 'jobTypes'
  | 'ecoSystems'
  index: string
}[]

export function formatFirmDataForWrappers(firm: Firm): FirmData {
  const data: FirmData = []
  let indexNb = 0

  Object.entries({ ...firm }).forEach(([key, value]) => {
    if (key === 'firmValues' && value) {
      data.push({
        data: value as string,
        type: 'firmValues',
        index: `data-${indexNb}`,
      })
    }
    if (key === 'clientDescription' && value) {
      data.push({
        data: value as string,
        type: 'clientDescription',
        index: `data-${indexNb}`,
      })
    }
    if (key === 'tools') {
      data.push({
        data: value as Tool[],
        type: 'tools',
        index: `data-${indexNb}`,
      })
    }
    if (key === 'jobTypes') {
      data.push({
        data: value as JobType[],
        type: 'jobTypes',
        index: `data-${indexNb}`,
      })
    }
    if (key === 'ecoSystems') {
      data.push({
        data: value as EcoSystem[],
        type: 'ecoSystems',
        index: `data-${indexNb}`,
      })
    }
    if (key === 'medias') {
      if (value && (value as mediaType[])) {
        let mediaIndexNb = 0
        const mediasArray = value as mediaType[]
        mediasArray.shift()
        mediasArray.forEach((media: mediaType) => {
          if (media?.video)
            data.push({
              data: media as mediaType,
              type: 'video',
              index: `mediadata-${mediaIndexNb}`,
            })
          if (media?.video === false) {
            data.push({
              data: media as mediaType,
              type: 'image',
              index: `mediadata-${mediaIndexNb}`,
            })
          }
          mediaIndexNb += 1
        })
      }
    }

    indexNb += 1
  })

  data.sort(() => Math.random() - 0.5)

  return data
}
